import { render, staticRenderFns } from "./iosTips.vue?vue&type=template&id=3aa19292&scoped=true"
import script from "./iosTips.vue?vue&type=script&lang=js"
export * from "./iosTips.vue?vue&type=script&lang=js"
import style0 from "./iosTips.vue?vue&type=style&index=0&id=3aa19292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa19292",
  null
  
)

export default component.exports